'use client';
// 商品頁 手機置底按鈕
import useUserStore from '@/store/useUserStore';
import useModalStore from '@/store/useModalStore';

interface Props {
    item: any;
    isDrawType: boolean;
    amount: number;
    isDisabled: boolean;
    buttonLabel: string;
}

const ItemBottomButton = ({ item, isDrawType, amount, isDisabled, buttonLabel }: Props) => {
    const { user } = useUserStore();
    const { openModal } = useModalStore();

    const { balance = 0, uid } = user || {};
    const { stardustCost = 0 } = item || {};

    // 此次兌換或抽獎需消耗的星塵數量
    const totalCost = isDrawType ? stardustCost * amount : stardustCost;

    // 點擊兌換或抽獎
    const onClick = () => {
        if (!uid) return openModal('LOGIN');
        if (balance < totalCost) return openModal('STARDUST_INSUFFICIENT');
        openModal(
            'ITEM',
            isDrawType ? { ...item, drawAmount: amount, balance } : { ...item, balance }
        );
    };

    return (
        <div className="bg-white fixed border-t border-black1 bottom-0 left-0 z-7 w-screen px-4 pt-3 pb-1.5 between-center lg:hidden">
            <div className="space-y-2">
                <p className="text-jblack text-btn3b">
                    需消耗<span className="text-vPurple px-1">{totalCost.toLocaleString()}</span>
                    星塵
                </p>
                <p className="text-btn2 text-black3">
                    持有星塵&nbsp;<span className="text-plum">{balance}</span>
                </p>
            </div>

            <button
                disabled={isDisabled}
                onClick={onClick}
                className="round text-[#fff] bg-vPurple text-btn1 py-3 px-10 trans hover:bg-purple disabled:bg-black2"
            >
                {buttonLabel}
            </button>
        </div>
    );
};

export default ItemBottomButton;
